import store from "@/redux/store";

import React, { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect, useSelector, useDispatch} from "react-redux";
import { Detail } from "@/views/team/Detail";
import UserAPI from "@/api/UserAPI";
import { addUser, loadUser, unsetSelected } from '@/reducers/User'
import { alert, info,success, error } from '@/reducers/Modal'

class TeamDetailController extends React.Component {
    
    
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null };
  }

    async componentDidMount() {
        const { dispatch, selectedId, type } = this.props;
        
        //if(isLoggedIn && user.id == 0) {
        try {
            if(selectedId) {
            await dispatch(loadUser(selectedId));
            } else {
                await dispatch(unsetSelected({type:type}));
            }
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {

      }            
    //  } 
    }
    
    componentWillUnmount() {
    }

    onSaveHandler = async (data) => {
        const { dispatch, type, RolesReducer } = this.props;

     try {
         if(!data) {
                data = this.props.userReducer.selected;
         }
         //data = this.props.userReducer.selected;
         data.type = type;
        await dispatch(addUser(data)).then((retData) => {
            if(!retData.error) {
                if(data.type == 1) {
                this.props.navigate("/team/", {"replace": true});
                } else if(data.type == 2) {
                    this.props.navigate("/ext-team/", {"replace": true});
                }
            }
        })
        if(!this.props.userReducer.error) {
            dispatch( alert({"header": "Opslaan gegevens", "description": "De gegevens zijn met succes opgeslagen!"}) );
        }
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {

      }
return;        
        UserAPI.storeUser(data)
            .then((response) =>   {
        })
        .catch((err) => {
            
        });     
    
    
    }

  render() {
      const {userReducer} = this.props;
      const {selected, key} = userReducer;
      let data = null
      if(selected && selected) {
        data = selected;
      }
      
    return (
      <Detail key={key} onSaveHandler={this.onSaveHandler} {...this.props} data={data} userDocuments={this.props?.documentReducer?.userDocuments}
      userRoles={this.props?.RolesReducer} sectors={this.props?.sectors}/>
    );
  }
}

const TeamDetailControllerInit = (props) => {
    const postStatus = useSelector(state => props.userReducer);
    let { id } = useParams();
    const navigate = useNavigate();
        const location = useLocation();

//  let { selectedFiles, selectedMap } = useParams();
  return (
    <TeamDetailController
      {...props}
      state={postStatus}
      selectedId={id}
      navigate={navigate}
      location={location}
    />
  );
};

function mapStateToProps(state) {
    const {UserReducer, DocumentReducer, RolesReducer, AuthReducer} = state;
  return {
      userReducer: UserReducer,
      documentReducer: DocumentReducer,
      RolesReducer: RolesReducer,
      sectors: AuthReducer?.sectors.getData(null, true)
  };
}

export default connect(mapStateToProps)(TeamDetailControllerInit);
